import { render, staticRenderFns } from "./crowd-statistics.vue?vue&type=template&id=bfbdd98a&"
import script from "./crowd-statistics.vue?vue&type=script&lang=ts&"
export * from "./crowd-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-statistics.vue?vue&type=style&index=0&id=bfbdd98a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports